/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

//# custom code to add gifts to baskets when using Shopifys buy x get y promo

(function() {
  let isProcessing = false;

  console.log("%c[Promo System] System active. Standalone network interceptor loaded.", "color: #00befa; font-weight: bold;");

  // 1. BACKGROUND LOOKUP ENGINE: FETCHES TAGS DIRECTLY VIA PRODUCT HANDLES
  async function fetchTagsByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const productData = await response.json();
        return productData.tags || [];
      }
    } catch (e) { console.error(`[Promo System] Error checking tags: ${handle}`, e); }
    return [];
  }

  // 2. CHECK CART METHOD FOR ADDITIONS / APPENDS
  async function runAddPromotionCheck(addedItemHandle) {
    if (isProcessing || !addedItemHandle) return;
    isProcessing = true;

    try {
      // Look up tags for the item that was just added to the cart
      const productTags = await fetchTagsByHandle(addedItemHandle);
      let promoId = null;
      let giftVariantId = null;

      productTags.forEach(tag => {
        const cleanTag = tag.trim();
        if (cleanTag.startsWith('promo_') && cleanTag.includes('_trig_')) {
          const parts = cleanTag.split('_trig_');
          promoId = parts[0].replace('promo_', '');
          giftVariantId = parseInt(parts[1], 10);
        }
      });

      if (promoId && giftVariantId) {
        // Double-check cart to make sure the gift isn't already inside
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(item => item.id === giftVariantId);

        if (!giftAlreadyInCart) {
          console.log(`%c[Promo System] Trigger matched for [${addedItemHandle}]. Adding gift variant: ${giftVariantId}`, "color: #10b981; font-weight: bold;");
          
          // Add the gift item quietly to the backend
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: giftVariantId,
                quantity: 1,
                properties: { '_promo_gift': promoId }
              }]
            })
          });

          // Command Venue's web components to refresh their content
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          const venueDrawer = document.querySelector('ajax-cart') || document.querySelector('cart-drawer');
          if (venueDrawer && typeof venueDrawer.refresh === 'function') {
            venueDrawer.refresh();
          }
        }
      }
    } catch (err) {
      console.error("[Promo System] Evaluation failed:", err);
    } finally {
      isProcessing = false;
    }
  }

  // 3. REMOVAL SWEEP ENGINE: DROPS GIFT IF THE TRIGGER LEAVES THE CART
  async function runOrphanCleanupSweep() {
    if (isProcessing) return;
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      let activePromoGroups = {};
      let giftsInCart = {};

      // Analyze item loops
      cart.items.forEach(item => {
        // Look up tags for each item to verify if a valid trigger is present
        const cleanPath = item.handle;
        if (cleanPath) activePromoGroups[cleanPath] = item.id;

        const properties = item.properties || {};
        if (properties['_promo_gift']) {
          giftsInCart[properties['_promo_gift']] = item.id;
        }
      });

      // Match up and check if any gift is left behind without its trigger
      const itemsToUpdate = {};
      for (const promoId in giftsInCart) {
        let triggerStillExists = false;
        
        // Scan handles in cart to see if the trigger is still alive
        for (const handle in activePromoGroups) {
          const tags = await fetchTagsByHandle(handle);
          tags.forEach(t => {
            if (t.includes(`promo_${promoId}_trig_`)) triggerStillExists = true;
          });
        }

        if (!triggerStillExists) {
          console.log(`%c[Promo System] Trigger left. Removing Gift Variant: ${giftsInCart[promoId]}`, "color: #ef4444; font-weight: bold;");
          itemsToUpdate[giftsInCart[promoId]] = 0;
        }
      }

      if (Object.keys(itemsToUpdate).length > 0) {
        isProcessing = true;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: itemsToUpdate })
        });
        isProcessing = false;
        
        const drawer = document.querySelector('ajax-cart') || document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
      }
    } catch(e) { isProcessing = false; }
  }

  // 4. THE LIVE NETWORK HOOK: OVERRIDE FETCH OBJECT WITHOUT STOPPING THE WINDOW
  const nativeFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = args[0];
    const options = args[1] || {};

    // Run the normal theme network action immediately so Venue handles everything natively
    const response = await nativeFetch.apply(this, args);

    if (typeof url === 'string') {
      // When an add action successfully completes, check for a promo match
      if (url.includes('/cart/add.js') || url.includes('/cart/add')) {
        try {
          // Read what was just added out of Venue's network call response body
          const clonedRes = response.clone();
          const addedData = await clonedRes.json();
          const handle = addedData.handle || (addedData.items && addedData.items[0]?.handle);
          
          if (handle) {
            // Check and append the gift cleanly behind the scenes
            setTimeout(() => { runAddPromotionCheck(handle); }, 50);
          }
        } catch (e) { console.warn("[Promo System] Couldn't parse item data handle from request."); }
      }
      
      // When items are updated or changed, check for orphan gifts
      if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        setTimeout(runOrphanCleanupSweep, 300);
      }
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', runOrphanCleanupSweep);
})();
